import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LabOrder} from '../shared/data/lab-order';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import {SubscriptionsContainer} from '../shared/subscriptions-container';
import {PrintPdfService} from '../shared/print-pdf.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/**
 *  This component uses pdfMake to generate and open a pdf of a lab order.
 *  pdfMake documentation: https://pdfmake.github.io/docs/
 *  pdfMake 'playground': http://pdfmake.org/playground.html
 *  Stackoverflow has a number of pdfMake questions.
 *  Note that popup/ad blockers may need to be disabled: https://github.com/bpampuch/pdfmake/issues/800
 *
 *  To understand the layout, it can be helpful to see the document with the table borders turned on. One way
 *  to do this is to find instances of "layout: 'noBorders'" and replace "layout:" with something like "zlayout:".
 */
@Component({
  selector: 'app-print-pdf',
  templateUrl: './print-pdf.component.html',
  styleUrls: ['./print-pdf.component.css']
})
export class PrintPdfComponent implements OnInit, OnDestroy {

  @Input() labOrder: LabOrder;
  @Output() myClick = new EventEmitter();

  labOrderNumber: string;
  subs = new SubscriptionsContainer();

  constructor(
    private route: ActivatedRoute,
    private printPdfService: PrintPdfService,
  ) {
  }

  ngOnInit() {
    console.log('init()');
    this.subs.add = this.route.params.subscribe(params => {
      this.labOrderNumber = params['labOrderNumber'];
    });
  }

  ngOnDestroy(): void {
    console.log(' Print PDF Component - ngOnDestroy ');
    this.subs.dispose();
  }

  printOrder() {
    this.printPdfService.createLabServiceReport([this.labOrderNumber]);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/print-pdf/print-pdf.component.ts